var mixins={
    
    methods: {
        //判断输入的不为空
        isNull(val)
        {
           return val==='';
        },
        //判断手机号
        isMobile(val){
            return /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[6]{1})|(19[9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(val);
        },
        //判断邮箱
        isEmail(val){
            return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(val);
        },
        //判断是否为邮箱或手机号
        isMobileOrEmail(val){
            return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(val)||/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[6]{1})|(19[9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(val);
        },
        //判断数字
        isNumber(val){
            return /^[0-9]*$/.test(val);
        },
        //以字母开头或下划线
        isCombination(val){
            return /^[a-zA-Z][a-zA-Z0-9_]*$/i.test(val);
        },
        //以字母或汉字组成
        isComb(val){
            return /^[A-Za-z\u4e00-\u9fa5]+$/i.test(val);
        },
        //判断不允许输入中文
        isNoChinese(val){
            let pattern=new RegExp("[^\u4e00-\u9fa5]"); return pattern.test(val);
        }

    },
}
export default mixins



// WEBPACK FOOTER //
// ./src/mixins/validator.js